import styles from "../../common/AlertCard.scss"; 
import Toggle from "../../common/Toggle";
import EmergencyAlertInfoPopup from "../../common/EmergencyInfoPopup";
import EmergencyAlertTurnOnPopup from "./Presentational/emergencyAlertTurnOnPopup";
import  HoverEAEmail from "./Common/hoverEAEmail";
import  HoverEAPhone from "./Common/hoverEAPhone";
import EmergencyAlertTurnOffPopup from "./Presentational/emergencyAlertTurnOffPopup";
import { getLocalizedStringstwo } from "../../centralizedLocalizedStringtwo";
import ReactHtmlParser from 'react-html-parser';
import EaDisableTurnOffPopup from "./Presentational/eaDisableTurnOffPopup";
class EmergencyAlertContainer extends React.Component { 
  constructor(props) {
    super(props);
    this.state={
      prefData:"", emailOn:null, phoneOn:null, textOn:null,checked:null,isOpen:false,isShowPopup: false,dropDownData:"",preferenceData:"", serviceAccountData:"",isErrorCard:false, isShowViewEdit:false, hoverData:'', hoverModal:false,hoverPhoneModal:false,hoverType:'',categoryType:'',toggleDisabled:true,
    };
    this.imageMail_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this.imageMail_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
    this.imagePhone_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
    this.imagePhone_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOff.svg';
    this.imageText_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
    this.imageText_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOff.svg';
    this.imageInfo=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
    let imageMailOn,imageMailOff,imageTextOn,imageTextOff,imagePhoneOn,imagePhoneOff,button;
    this.button= <button id="emergencyAlertView" className={styles.ViewEditButton} onClick={this.showViewEditPopup.bind(this)}>View / Edit</button>;
    this.strings = getLocalizedStringstwo('EmergencyAlerts');
    this.initialPositionValue = window.getComputedStyle(document.body).position;
  }
  viewHoverPopUp =()=>{ 
    this.props.preferenceData.email_id.length >0 && this.setState({ hoverModal: true , categoryType:'3'});
  }
  viewHoverPhone =(category)=>{ 
    if(category===1 && this.props.preferenceData.textNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.textNo ,hoverPhoneModal: true,hoverModal: false,hoverType:'text', categoryType:'1' });
    } else if(category===2 && this.props.preferenceData.phoneNo.length > 0){
      this.setState({ hoverData: this.props.preferenceData.phoneNo ,hoverPhoneModal: true, hoverModal: false,hoverType:'voice', categoryType:'2'});
    }
  }
  componentDidUpdate() {
    // Bind the event listener
    this.state.categoryType==='3'? document.addEventListener("mousedown", this.handleEmailClose):document.addEventListener("mousedown", this.handlePhoneClose);
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount(){
    this.state.categoryType==='3'? document.removeEventListener("mousedown", this.handleEmailClose):document.removeEventListener("mousedown", this.handlePhoneClose);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleEmailClose=()=>{  this.state.hoverModal?this.setState({ hoverModal: false }):null;}
  handlePhoneClose=()=>{  this.state.hoverPhoneModal?this.setState({ hoverPhoneModal: false }):null;
 }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
    this.setState( {
        prefData:nextProps.preferenceData,
        emailOn:nextProps.preferenceData.email_id.length>0?true:false,
        phoneOn:nextProps.preferenceData.phoneNo.length>0?true:false,
        textOn:nextProps.preferenceData.textNo.length>0?true:false,
      },
      () => {
        this.handle();
      }
    );
  }
}
emergencyAlertEnrollClick(requestObj, viewState){
  app.centralizedService.emergencyAlertEnroll(this.props.accountData.bpNumber, this.props.accountData.bpCategory, requestObj.enrollmentArray, this.props.selectedAccount,this.props.mainBpNumber,this.props.accountData.contractAccountNumber).then(
    (response) =>{
      this.setState({isErrorCard:false});
      this.closePopup();
      // adding 600ms delay for refresh when its single account
      let timeout = this.props.isMultiAcc === 1 ? 0 : 600;
      setTimeout(() => {
      this.props.refreshPage(this.props.accountData.contractAccountNumber, this.props.selectedAccount.contractNumber, this.props.selectedAccount.premiseNumber,false, this.props.accountData.bpNumber, this.props.accountData.bpCategory);
    }, timeout);
  }, (error) => {
    this.setState({isErrorCard: true});
  });
}
onModifyCustomerPreference(requestObj, viewState, addNewDevieDetailFlag, deleteDeviceDetailFlag) {
      let dropDownData = this.state.dropDownData;
      if(requestObj.deviceType==="email"){
          let newObj={
            "email": requestObj.modifiedValue,
            "standardIndicatorEmail": "",
            "objectKey": "",
            "record_guid": "NEW",
            "channel": "INT",
            "sequenceNumber": "",
            "status": "",
            "removeFromDate": null,
            "addModifyFromDate": null,
            "addModifyToDate": null
        };
        dropDownData.emailSet.push(newObj);
      }
      else if(requestObj.deviceType==="voice"){
        let newObj={
          "telephoneNumber": requestObj.maskedValue,
          "encryptedPhoneNumber":requestObj.modifiedValue,
          "standardIndicatorVoice": "",
          "objectKey": "",
          "record_guid": "NEW",
          "channel": "TEL",
          "sequenceNumber": "",
          "indicatorSmsEnabled": "X",
          "indicatorTelephone": "",
          "status": "",
          "removeFromDate": null,
          "addModifyFromDate": null,
          "addModifyToDate": null
        };
        dropDownData.phoneSet.push(newObj);
        let mobileObject={...newObj, "channel": "PAG"};
        dropDownData.mobileSet.push(mobileObject);
      }else{
        let newObj={
          "telephoneNumber": requestObj.maskedValue,
          "encryptedPhoneNumber":requestObj.modifiedValue,
          "standardIndicatorVoice": "",
          "objectKey": "",
          "record_guid": "NEW",
          "channel": "PAG",
          "sequenceNumber": "",
          "indicatorSmsEnabled": "X",
          "indicatorTelephone": "",
          "status": "",
          "removeFromDate": null,
          "addModifyFromDate": null,
          "addModifyToDate": null
        };
        dropDownData.mobileSet.push(newObj);
        let mobileObject={...newObj, "channel": "TEL"};
        dropDownData.phoneSet.push(mobileObject);
      }
      this.props.updateDropDownData(dropDownData);
    }
 

getFormattedPreferenceData(){
  let preferenceData={emailSet:[],mobileSet:[],phoneSet:[]};
  _.each(this.props.formattedDataForEmrg.email_id, function(email){
      let preferenceSavedDateMilliSec = email.validFromDate ? email.validFromDate.indexOf('/')===0 ? email.validFromDate.slice(6,-2) : email.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
          email: email.email_id || "",
          standardIndicatorEmail: email.standardIndicatorEmail || '',
          objectKey: email.objectKey || '',
          record_guid: email.record_guid || 'NEW',
          channel: 'INT',
          sequenceNumber: email.sequenceNumber || '',
          status: email.status || '',
          removeFromDate: preferenceSavedEDMDate,
          addModifyFromDate: email.contactValidFrom || null,
          addModifyToDate: email.contactValidTo || null
      };
        preferenceData.emailSet.push(data);
  });
  _.each(this.props.formattedDataForEmrg.phoneNo, function(phone){
      let preferenceSavedDateMilliSec = phone.validFromDate ? phone.validFromDate.indexOf('/')===0 ? phone.validFromDate.slice(6,-2) : phone.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
          telephoneNumber: phone.maskedPhoneNumber ? phone.maskedPhoneNumber.replace(/-/g, '') :'',
          encryptedPhoneNumber: phone.encryptedPhoneNumber || "",
          standardIndicatorVoice: phone.standardIndicatorPhoneNumber || '',
          objectKey: phone.objectKey || '',
          record_guid: phone.record_guid || 'NEW',
          channel: 'TEL',
          sequenceNumber: phone.sequenceNumber || '',
          indicatorSmsEnabled: phone.indicatorSmsEnabled  || '', 
          indicatorTelephone: phone.indicatorTelephone || '', 
          status: phone.status || '',
          removeFromDate: preferenceSavedEDMDate,
          addModifyFromDate: phone.contactValidFrom || null,
          addModifyToDate: phone.contactValidTo || null
      };
        preferenceData.phoneSet.push(data);
  });
  _.each(this.props.formattedDataForEmrg.textNo, function(text){
      let preferenceSavedDateMilliSec = text.validFromDate ? text.validFromDate.indexOf('/')===0 ? text.validFromDate.slice(6,-2) : text.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
          telephoneNumber: text.maskedText ? text.maskedText.replace(/-/g, '') : '',
          encryptedPhoneNumber: text.encryptedText || "",
          standardIndicatorText: text.standardIndicatorPhoneNumber || '',
          objectKey: text.objectKey || '',
          record_guid: text.record_guid || 'NEW',
          channel: 'PAG',
          sequenceNumber: text.sequenceNumber || '',
          indicatorSmsEnabled: text.indicatorSmsEnabled || '', 
          indicatorTelephone: text.indicatorTelephone || '', 
          status: text.status || '',
          removeFromDate: preferenceSavedEDMDate,
          addModifyFromDate: text.contactValidFrom || null,
          addModifyToDate: text.contactValidTo || null
      };
      preferenceData.mobileSet.push(data);
  });
  return preferenceData;
}
  handle(){
    let preferenceData = this.getFormattedPreferenceData();
    let accountData = this.props.selectedAccount;
    let serviceAccountData = {
      'saAccList': [
        {
          'contractNumber': accountData.contractNumber, 'email': '', 'houseNumber': accountData.houseNumber, 'unitNumber': '',
          'address': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
          'sreetAddress': accountData.streetAddress,
          'city': accountData.city,
          'state': accountData.state,
          'zipCode': accountData.zipcode,
          'premiseNumber': accountData.premiseNumber,
          'serviceAddress': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
          'serviceAccountIndex': 0,
          'isSelected': true
        }
      ],
      'serviceAccountCount': 1
    };
    let emrgOpenPopup = app.appService.getSessionstorage('openPopupData') ? app.appService.getSessionstorage('openPopupData').emrg : false;
    emrgOpenPopup ?  app.appService.removeSessionStorageItem('openPopupData') : null;
    let checked = this.state.emailOn ||this.state.phoneOn || this.state.textOn ? true : false;
    this.setState({checked: checked, isShowPopup: this.state.isShowPopup || emrgOpenPopup, isShowViewEdit: this.state.isShowViewEdit || (emrgOpenPopup && checked),
      preferenceData: preferenceData,dropDownData: this.props.dropDownData,serviceAccountData: serviceAccountData,toggleDisabled: false});
    this.imageMailOn=this.state.emailOn ? <img src={this.imageMail_On} alt="Mail Image On" />:<img src={this.imageMail_Off} alt="Mail Image Off" />;
    this.imagePhoneOn=this.state.phoneOn ? <img src={this.imagePhone_On} alt="Phone Image On" /> : <img src={this.imagePhone_Off} alt="Phone Image Off" />;
    this.imageTextOn=this.state.textOn ? <img src={this.imageText_On} alt="Text Image On" /> : <img src={this.imageText_Off} alt="Text Image Off" />;
}
showViewEditPopup(){
  this.setState({ isShowViewEdit: true,isShowPopup:true}, () => { });
  window.aUtils.sendAAEvent("button","emergencyview/edit");
  window.scrollTo(0,0);
}
handleToggleChange = (checked) => {
    this.setState({isShowPopup: true});
    window.scrollTo(0,0);
}
closePopup = () => { this.setState({isShowPopup: false,isShowViewEdit:false,isErrorCard: false});}
emergencyAlertDeEnrollClick =()=>{
  window.aUtils.sendAAEvent("button","emergencyturnoff");
  app.centralizedService.emergencyAlertDeenroll(this.props.accountData.bpNumber, this.props.accountData.bpCategory, this.props.formattedDataForEmrg,this.props.mainBpNumber).then(
      (response )=>{
    
      if(!response.errorCode){
        this.setState({checked: false, isErrorCard: false},()=>{        
          this.props.removePreference('emrg', 'formattedDataForEmrg');
          this.closePopup();
        });      
      }
      else{    
        this.setState({isErrorCard:true});
      }
    },(error) => {       
    this.setState({isErrorCard:true});});}
overlayFocusController() {
  if(this.state.isShowPopup) {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  } else {
    document.body.style.position = this.initialPositionValue;
    document.body.style.removeProperty("width");}}
onHoverOverEvent =(e)=>{ e.type === "mouseenter" && this.setState({infoPopUp:true});}
onHoverOutEvent = (e) =>{this.setState({infoPopUp:false});}
toolTipKeyPress= (e) =>{
  if(e.key === "Enter"){
    this.setState({infoPopUp:!this.state.infoPopUp});}}
  render() {
    this.overlayFocusController();
    let showEmergencyAlertInfoPopup = this.state.infoPopUp ? <div><EmergencyAlertInfoPopup infoPopupTxt={ReactHtmlParser(this.props.staticContent.infoPopupTxt)} /> </div>: null;
    let turnOnOffPopup = !this.state.checked || this.state.isShowViewEdit ?
    <EmergencyAlertTurnOnPopup strings={this.strings} closePopup={this.closePopup} preferenceData={this.state.preferenceData}
    serviceAccountData={this.state.serviceAccountData}  emergencyAlertEnrollClick={this.emergencyAlertEnrollClick.bind(this)} mainBpNumber={this.props.mainBpNumber}
    onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)}  dropDownData={this.state.dropDownData} isErrorCard={this.state.isErrorCard}
    contractAccountNumber={this.props.accountData.contractAccountNumber} selectedAccount={this.props.selectedAccount}
    isViewEdit={this.state.isShowViewEdit} /> : (this.props.accountData.onlyOneBpEnrolled || this.props.onlyOneBpEnrolled) ? <EaDisableTurnOffPopup handleClose={this.closePopup} /> : <EmergencyAlertTurnOffPopup handleClose={this.closePopup} accountData={this.props.accountData} selectedAccount={this.props.selectedAccount}  emergencyAlertDeEnrollClick={this.emergencyAlertDeEnrollClick} isErrorCard={this.state.isErrorCard} /> ;
    let showPopup = this.state.isShowPopup ? turnOnOffPopup : null;
  return (
   <div>
       <div className={[styles.AlertCards,styles.relativePos].join(' ')}>
           <div className={styles.MainContainer}>
               <div className={styles.LeftContainer}>
                   <div className={styles.AlertCardData} onMouseLeave={this.onHoverOutEvent}>
                        <p className={styles.AlertCardTitle} id={'emergencyAlertInfoPopUp'} onMouseEnter={this.onHoverOverEvent} onClick={this.onHoverOverEvent}>
                            {this.strings.emergencyAlertHeader1}<span className={styles.InfoIcon}>{this.strings.emergencyAlertHeader2}<img tabIndex={0} onKeyPress={this.toolTipKeyPress} className={styles.iconAlign} src={this.imageInfo} alt="Info Icon"  /></span>
                        </p>
                        {showEmergencyAlertInfoPopup}
                        {this.state.hoverModal && <HoverEAEmail  preferenceData={this.props.preferenceData.email_id} handleEmailClose={this.handleEmailClose.bind(this)} />}
                        {this.state.hoverPhoneModal && <HoverEAPhone  preferenceDataPhone={this.state.hoverData} hoverText={this.state.hoverType} handlePhoneClose={this.handlePhoneClose.bind(this)} />}
                        <p className={styles.AlertCardSubtitle} onMouseEnter={this.onHoverOutEvent}> {ReactHtmlParser(this.props.staticContent.subTxt)}</p>
                        <div className={styles.ButtonSection}>{(this.state.checked)?<span><span onClick={this.viewHoverPopUp.bind(this)}> {this.imageMailOn}</span><span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,1)}>{this.imageTextOn}</span><span className={styles.MarginLeft16} onClick={this.viewHoverPhone.bind(this,2)}>{this.imagePhoneOn}</span>{this.button}</span>:null}</div>
                    </div>
                </div>
                <div className={styles.DividerLine} />
                <div className={styles.RightContainer}>
                    <div className={styles.SwitchAlign}><Toggle id="emergency" isToggleOn={this.state.checked} handleChange={this.handleToggleChange} isDisabled={this.state.toggleDisabled} /></div>
                </div>
            </div>
        </div>
        {showPopup}
    </div>
    );
  }
}
export default EmergencyAlertContainer;
